import { trimStringsInObject, applyWaterValue } from './utils';
import { createEquipmentWithUsages } from '../../../offline/createApi';

export function useWaterpointAPI(isEditMode) {
    const fetchEquipmentData = async (id_equipment) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/load_equipment/${id_equipment}`);
        if (!response.ok) throw new Error("Erreur lors de la récupération de l'équipement");
        const data = await response.json();
        // Convert timer from minutes to seconds for display
        if ((data.type_equipment === 'faucet' || data.type_equipment === 'shower')
            && data.technical_data.activation_mode === 'push_button'
            && data.technical_data.timer_duration) {
            data.technical_data.timer_duration *= 60;
        }
        return data;
    };

    const fetchUsagesData = async (id_equipment) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/load_usages_by_equipment_id/${id_equipment}`);
        if (!response.ok) throw new Error("Erreur lors de la récupération des usages");
        return await response.json();
    };

    // Create mode goes through createApi.js so it transparently queues for
    // offline sync when there's no connectivity (isEditMode stays online-only,
    // per v1 scope). Returns the offline/createApi.js result so the caller can
    // adapt its toast/UI messaging.
    const save = async (equipmentData, usages, { isOnline = true, loadedUsageIds = [] } = {}) => {
        const preparedEquipment = applyWaterValue(trimStringsInObject({ ...equipmentData }));
        const preparedUsages = usages.map(trimStringsInObject);

        if (isEditMode) {
            await updateEquipment(preparedEquipment);
            await updateUsages(preparedUsages, preparedEquipment._id, loadedUsageIds);
            return { ok: true, offline: false };
        }
        const result = await createEquipmentWithUsages(preparedEquipment, preparedUsages, { isOnline });
        // Include the fully-prepared equipment (water_value computed, strings
        // trimmed) so the caller can merge exactly what was persisted into its
        // local state when offline, instead of the raw pre-save equipmentData.
        return { ...result, equipmentData: preparedEquipment };
    };

    return { fetchEquipmentData, fetchUsagesData, save };
}

// ─── Private helpers (edit mode only — stays online-only in v1) ───────────────

async function updateEquipment(data) {
    const r = await fetch(`${process.env.REACT_APP_API_URL}/update_equipment/${data._id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data)
    });
    if (!r.ok) alert("Erreur lors de la mise à jour de l'équipement.");
}

async function updateUsages(usages, equipmentId, loadedUsageIds) {
    const r = await fetch(`${process.env.REACT_APP_API_URL}/update_usages`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usages, equipment_id: equipmentId, loaded_usage_ids: loadedUsageIds })
    });
    if (!r.ok) alert("Erreur lors de la mise à jour des usages.");
}
